import { useState, useEffect, useCallback } from 'react';
import api from '../../api';
import Layout from '../../components/Layout';
import stili from '../../components/competenze/stili';
import { usePuoScrivere } from '../../utils/permessi';
import { formattaData } from '../../utils/date';
import { formattaEuro } from '../../utils/importi';
import './competenze.css';

const quando = iso => (iso ? new Date(iso).toLocaleString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '');

// Cestino di Parcellazione: competenze eliminate. Si vede con la lettura, si ripristina con la scrittura.
export default function CestinoCompetenze() {
  const puoScrivere = usePuoScrivere('competenze');
  const [righe, setRighe] = useState([]);
  const [selezionate, setSelezionate] = useState([]);
  const [esito, setEsito] = useState(null);   // { ripristinate, non_ripristinate }
  const [errore, setErrore] = useState('');
  const [inCorso, setInCorso] = useState(false);

  const carica = useCallback(async () => {
    try {
      const res = await api.get('/competenze/cestino');
      setRighe(res.data.competenze);
      setSelezionate(sel => sel.filter(id => res.data.competenze.some(c => c.id === id)));
    } catch (err) {
      setErrore(err.response?.data?.errore || 'Errore nel caricamento');
    }
  }, []);
  useEffect(() => { carica(); }, [carica]);

  const ripristina = async (ids) => {
    if (inCorso || !ids.length) return;
    setErrore('');
    setInCorso(true);
    try {
      const res = await api.post('/competenze/cestino/ripristina', { ids });
      setEsito(res.data);
    } catch (err) {
      // Una sola riga rifiutata (per esempio pratica già reinviata dallo Scadenziario): il motivo arriva come errore
      const non = err.response?.data?.non_ripristinate;
      if (non) setEsito({ ripristinate: 0, non_ripristinate: non });
      else setErrore(err.response?.data?.errore || 'Ripristino non riuscito');
    } finally {
      window.dispatchEvent(new Event('cestino-aggiornato'));
      setInCorso(false);
      setSelezionate([]);
      carica();
    }
  };

  const tutte = righe.length > 0 && selezionate.length === righe.length;

  return (
    <Layout>
      <div style={stili.topBar}>
        <h2 style={{ margin: 0 }}>Cestino di Parcellazione</h2>
      </div>
      <p style={{ color: '#555', fontSize: '0.88rem', marginTop: 0 }}>Competenze eliminate. {puoScrivere ? 'Ripristinale una alla volta o in blocco.' : 'Per ripristinarle serve il permesso di scrittura.'}</p>

      {errore && <div style={stili.errore}>{errore}</div>}

      {puoScrivere && selezionate.length > 0 && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', background: '#232323', color: 'white', padding: '0.6rem 0.9rem', borderRadius: '8px', marginBottom: '0.8rem', flexWrap: 'wrap' }}>
          <strong>{selezionate.length} selezionate</strong>
          <button onClick={() => ripristina(selezionate)} disabled={inCorso} style={{ ...stili.btn, background: '#D3D678', color: '#232323', fontWeight: 600 }}>
            {inCorso ? 'Ripristino…' : 'Ripristina selezionate'}
          </button>
          <button onClick={() => setSelezionate([])} style={stili.btnSmall}>Annulla selezione</button>
        </div>
      )}

      {esito && (
        <div role="status" style={{ border: `1px solid ${esito.non_ripristinate.length ? '#fdba74' : '#86efac'}`, background: esito.non_ripristinate.length ? '#fff7ed' : '#ecfdf5', borderRadius: '8px', padding: '0.7rem 0.9rem', marginBottom: '0.8rem', fontSize: '0.88rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
            <strong>{esito.ripristinate} {esito.ripristinate === 1 ? 'ripristinata' : 'ripristinate'}{esito.non_ripristinate.length ? `, ${esito.non_ripristinate.length} non ripristinate` : ''}</strong>
            <button onClick={() => setEsito(null)} style={stili.btnSmall}>Chiudi</button>
          </div>
          {esito.non_ripristinate.length > 0 && (
            <ul style={{ margin: '0.4rem 0 0', paddingLeft: '1.2rem', color: '#9a3412' }}>
              {esito.non_ripristinate.map(x => <li key={x.id}><strong>{x.riferimento}</strong>: {x.motivo}</li>)}
            </ul>
          )}
        </div>
      )}

      <div style={{ overflowX: 'auto' }}>
        <table style={stili.table}>
          <thead>
            <tr>
              {puoScrivere && <th style={{ ...stili.th, width: '2.2rem' }}>
                <input type="checkbox" aria-label="Seleziona tutte" checked={tutte} onChange={e => setSelezionate(e.target.checked ? righe.map(c => c.id) : [])} />
              </th>}
              <th style={stili.th}>Azienda</th>
              <th style={stili.th}>Fatturante</th>
              <th style={stili.th}>Descrizione</th>
              <th style={stili.th}>Data</th>
              <th style={stili.th}>Importo</th>
              <th style={stili.th}>Eliminata il</th>
              <th style={stili.th}>Eliminata da</th>
              {puoScrivere && <th style={stili.th} />}
            </tr>
          </thead>
          <tbody>
            {righe.map(c => (
              <tr key={c.id} style={{ ...stili.tr, ...(selezionate.includes(c.id) ? { background: '#F7F7EA' } : {}) }}>
                {puoScrivere && <td style={stili.td}>
                  <input type="checkbox" aria-label={`Seleziona prestazione ${c.id}`} checked={selezionate.includes(c.id)}
                    onChange={e => setSelezionate(s => (e.target.checked ? [...s, c.id] : s.filter(x => x !== c.id)))} />
                </td>}
                <td style={stili.td}>{c.cliente}{c.cliente_eliminato && <span style={{ color: '#c2410c', fontSize: '0.76rem' }}> (azienda nel Cestino)</span>}</td>
                <td style={stili.td}>{c.fatturante || <span style={{ color: '#999' }}>—</span>}</td>
                <td style={stili.td}>{c.descrizione}</td>
                <td style={{ ...stili.td, whiteSpace: 'nowrap' }}>{formattaData(c.data)}</td>
                <td style={{ ...stili.td, whiteSpace: 'nowrap' }}>{c.importo !== null && c.importo !== undefined ? formattaEuro(c.importo) : ''}</td>
                <td style={{ ...stili.td, whiteSpace: 'nowrap' }}>{quando(c.eliminato_il)}</td>
                <td style={stili.td}>{c.eliminato_da_nome}</td>
                {puoScrivere && <td style={stili.td}>
                  <button onClick={() => ripristina([c.id])} disabled={inCorso || c.cliente_eliminato} style={stili.btnSmall}
                    title={c.cliente_eliminato ? "Ripristina prima l'azienda" : undefined}>Ripristina</button>
                </td>}
              </tr>
            ))}
            {righe.length === 0 && (
              <tr><td colSpan={puoScrivere ? 9 : 7} style={{ ...stili.td, textAlign: 'center', color: '#999', padding: '1.5rem' }}>Il Cestino è vuoto</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </Layout>
  );
}
